import React from "react";
import { Label, Wrapper, StyledInput, ErrorMessage } from "./style";

interface IProps {
  label: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  error?: string;
  labelStyle?: React.CSSProperties;
  type?: string;
  disabled?: boolean;
  mask?: string;
  required?: boolean;
}

export const Input = ({ label, placeholder, value, onChange, error, labelStyle, type, disabled, mask="", required }: IProps) => {
  return (
    <Wrapper>
      <Label style={labelStyle}>{label}</Label>
      <StyledInput required={required} mask={mask} disabled={disabled} type={type} placeholder={placeholder} value={value} onChange={onChange} />
      {
        error && (
          <ErrorMessage>{error}</ErrorMessage>
        )
      }
    </Wrapper>
  );
}